import StationType from "enums/station-type";

export const stationTypeOptions = [
  {
    label: StationType.DODOX,
    value: StationType.DODOX,
  },
  {
    label: StationType.WIDOX,
    value: StationType.WIDOX,
  },
  {
    label: StationType.UWIDOX,
    value: StationType.UWIDOX,
  },
  {
    label: StationType.COCO,
    value: StationType.COCO,
  },
  {
    label: StationType.CODOX,
    value: StationType.CODOX,
  },
  {
    label: StationType.COXO,
    value: StationType.COXO,
  },
  {
    label: StationType.WILCO,
    value: StationType.WILCO,
  },
  {
    label: StationType.WIBCO,
    value: StationType.WIBCO,
  },
  {
    label: StationType.CODO,
    value: StationType.CODO,
  },
  {
    label: StationType.DODO,
    value: StationType.DODO,
  },
  {
    label: StationType.XDODO,
    value: StationType.XDODO,
  },
  {
    label: StationType.XDODO_W,
    value: StationType.XDODO_W,
  },
  {
    label: StationType.XWIDO,
    value: StationType.XWIDO,
  },
  {
    label: StationType.XWIDO_W,
    value: StationType.XWIDO_W,
  },
  {
    label: StationType.UDODOX,
    value: StationType.UDODOX,
  },
  {
    label: StationType.CODOL,
    value: StationType.CODOL,
  },
];
